<template>
    <div>
      <div v-if="webPageType">
        {{ webPageTypeOptions.filter(option => option.value === webPageType)?.[0].text }}
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        Not selected
      </div>
    </div>
</template>

<script>
import {
  STEPS,
} from "@/components/FullPageSourceEditorV2/components/AiWriter/constants.js";

export default {
    name: 'ConfigPreviewWebPageType',
    props: [
        'webPageTypeOptions',
        'webPageType',
    ],
    computed: {
        STEPS() {
          return STEPS
        },
    }
}
</script>

<style lang="scss" scoped>

</style>